export default __webpack_public_path__ + "static/media/TETA_Logo.7eeed373.png";